// extracted by mini-css-extract-plugin
export default {"galleryNavigationContainer":"GalleryNavigation_galleryNavigationContainer__D6daN","disabled":"GalleryNavigation_disabled__P1uZs"};